import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { label: "Inicio", path: "/" },
  { label: "Servicios", path: "/servicios" },
  { label: "Compra-venta", path: "/vehiculos" },
  { label: "Sobre nosotros", path: "/sobre-nosotros" },
  { label: "Contacto", path: "/contacto" },
  { label: "FAQ", path: "/faq" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? "bg-[#1a1a1a] shadow-lg" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between h-20">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3 cursor-pointer">
          <img
            src="https://static.readdy.ai/image/7706d3d6489b410b65ff8a4349b3c2a0/223188088ced14bde9ca20537aa2eaa5.png"
            alt="GERPAT Logo"
            className="h-12 w-auto object-contain"
          />
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`px-4 py-2 text-sm font-medium rounded-md transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === link.path
                  ? "text-[#FF6B35] bg-white/10"
                  : "text-white hover:text-[#FF6B35] hover:bg-white/10"
              }`}
            >
              {link.label}
            </Link>
          ))}
          <a
            href="tel:+34638250936"
            className="ml-4 flex items-center gap-2 bg-[#FF6B35] hover:bg-[#e55a25] text-white text-sm font-semibold px-5 py-2.5 rounded-full transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-fill text-base"></i>
            Llamar ahora
          </a>
        </nav>

        {/* Mobile hamburger */}
        <button
          className="md:hidden text-white text-2xl cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Abrir menú"
        >
          <i className={menuOpen ? "ri-close-line" : "ri-menu-line"}></i>
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="md:hidden bg-[#1a1a1a] border-t border-white/10 px-4 py-4 flex flex-col gap-1">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`px-4 py-3 text-sm font-medium rounded-md transition-colors cursor-pointer ${
                location.pathname === link.path
                  ? "text-[#FF6B35] bg-white/10"
                  : "text-white hover:text-[#FF6B35]"
              }`}
            >
              {link.label}
            </Link>
          ))}
          <a
            href="tel:+34638250936"
            className="mt-2 flex items-center justify-center gap-2 bg-[#FF6B35] text-white text-sm font-semibold px-5 py-3 rounded-full cursor-pointer"
          >
            <i className="ri-phone-fill"></i>
            Llamar ahora
          </a>
        </div>
      )}
    </header>
  );
}
